import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';

/**
 * Guards the Back action on the Confirm Job Details page.
 *
 * Parsing already persisted the draft, so leaving never loses the import itself —
 * but it would discard any edits the office has made on this review screen. When
 * the form is dirty, Back opens a confirmation popup; when it is pristine, Back
 * navigates away immediately (there is nothing to lose).
 */
export const useConfirmJobDetailsExit = (isDirty: boolean) => {
  const navigate = useNavigate();
  const [isExitConfirmOpen, setIsExitConfirmOpen] = useState(false);

  const leave = useCallback(() => navigate(-1), [navigate]);

  const requestExit = useCallback(() => {
    if (isDirty) {
      setIsExitConfirmOpen(true);
      return;
    }
    leave();
  }, [isDirty, leave]);

  const cancelExit = useCallback(() => setIsExitConfirmOpen(false), []);

  const confirmExit = useCallback(() => {
    setIsExitConfirmOpen(false);
    leave();
  }, [leave]);

  return { isExitConfirmOpen, requestExit, cancelExit, confirmExit };
};
